import React from "react";
import ReactDom from "react-dom";
import "./styles/global.scss";
import App from "./pages/_app";
import * as serviceWorker from "./serviceWorker";
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './store/reducers/rootReducer';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { reduxFirestore, getFirestore, createFirestoreInstance } from 'redux-firestore';
import { ReactReduxFirebaseProvider, getFirebase } from 'react-redux-firebase';
import {firebase, config} from 'util/auth';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_KEY,
    releaseStage: process.env.REACT_APP_BUGSNAG_ENVIRONMENT,
    plugins: [new BugsnagPluginReact()]
});

const composeEnhancers =
    typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: "Sutra Dev" })
        : compose;

const store = createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
        reduxFirestore(firebase, config)
    )
);

const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React)

const rrfProps = {
    firebase,
    config: config,
    dispatch: store.dispatch,
    createFirestoreInstance
};

ReactDom.render(
<ErrorBoundary>
    <Provider store={store}>
        <ReactReduxFirebaseProvider {...rrfProps}>
            <App />
        </ReactReduxFirebaseProvider>
    </Provider>
</ErrorBoundary>, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
